import React, { useState, useEffect } from "react";
import axios from 'axios'
import Swal from 'sweetalert2';

import Guest from "../../../layouts/Guest";
import NewYearCheckInConfirmation from "../../../components/Private/CheckIn/NewYearCheckInConfirmation";
import { useGuestContext } from '../../../contexts/GuestContext';

function NewYearCheckInPage() {
    const [details, setDetails] = useState(null);
    const [guestId, setGuestId] = useState(null);
    const [eventNumber, setEventNumber] = useState(1);
    const { language } = useGuestContext();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        // Get 'guestid' from the URL
        let id = params.get('guestid');
        if (!id) {
            id = params.get('id');
        }
        // Get 'event' from the URL (defaults to 1)
        const event = parseInt(params.get('event')) || 1;

        if (id) {
            setGuestId(id);
            setEventNumber(event);
            fetchGuestDetails(id, event);
        }
    }, []);


    const fetchGuestDetails = async (guestId, event) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/newyear/checkinrequest?guestid=${guestId}&event=${event}`);
            if (response.data && response.data.status === 'success') {
                console.log(response.data.details)
                setDetails({ ...response.data.details, selectedEvent: event });
            } else if (response.data && response.data.status === 'checkedIn') {
                // Guest is already checked in for this event
                const eventName = event === 1
                    ? '歲末祈福法會'
                    : '新春合禮團拜會';
                const checkedInTime = response.data.details.checkedInTime || 'Unknown time';
                Swal.fire({
                    title: language === "English" ? `Already checked in` : `已報到`,
                    text: language === "English"
                        ? `Guest ID: ${guestId} has already checked in for "${eventName}" at ${checkedInTime}.`
                        : `ID為${guestId}的居士已於 ${checkedInTime} 報到「${eventName}」。`,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                }).then(() => {
                    window.location.href = '/newyear/checkinSearch';
                });
            } else {
                // Guest not found
                Swal.fire({
                    title: language === "English" ? `Guest with ID: ${guestId} not found` : `未找到ID為${guestId}的居士`,
                    text: language === "English" ? "Please ensure the guest has completed the registration" : "請確認這位居士已完成報名",
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                }).then(() => {
                    window.location.href = '/newyear/checkinSearch';
                });
            }
        } catch (error) {
            Swal.fire('Error', 'An error occurred while fetching guest data', 'error').then(() => {
                window.location.href = '/newyear/checkinSearch';
            });
        }
    };


    return (
        <>
            <Guest>
                {details && <NewYearCheckInConfirmation details={details} />}
            </Guest>
        </>
    );
}

export default NewYearCheckInPage;
